import React from "react";
import { Box, Card, CardContent, Typography, Grid, List, ListItem, ListItemText, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { Icon } from "@iconify/react";


function CookieScanReport({ data }) {
  return (
    <Paper elevation={3} sx={{ padding: 3, width: "100%", maxWidth: 900, margin: '0 auto' }}>
      <Box >
      {/* Title & Target Domain */}
      <Typography variant="h4" sx={{ fontWeight: "bold", color: "rgb(0, 145, 70)", mb: 2,textAlign:'center' }}>
        Cookie Scan Report
      </Typography>
      
      <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
        Target: {data.target}
      </Typography>

      {/* Grades Summary */}
      <Card sx={{ mt: 2, mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Compliance & Grades
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <Chip label={`Final Grade: ${data.grades.finalGrade}`} color="success" sx={{ fontSize: "1rem", fontWeight: "bold" }} />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Chip
                label={`Compliance: ${data.result.complianceStatus.compliant ? "Compliant" : "Non-Compliant"}`}
                color={data.result.complianceStatus.compliant ? "success" : "error"}
                sx={{ fontSize: "1rem", fontWeight: "bold" }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Non-Compliant Cookies */}
      {!data.result.complianceStatus.compliant && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              Non-Compliant Cookies
            </Typography>
            <List dense>
              {data.result.complianceStatus.nonCompliantCookies.map((cookie, index) => (
                <ListItem key={index}>
                  <ListItemText primary={`🚨 ${cookie}`} />
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      )}

      {/* Cookie Categories */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Cookie Categories Breakdown
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(data.result.categories).map(([category, count]) => (
              <Grid item xs={6} sm={3} key={category}>
                <Chip label={`${category.charAt(0).toUpperCase() + category.slice(1)}: ${count}`} sx={{ fontSize: "1rem", fontWeight: "bold" }} />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* Security Warnings */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Security Warnings & Recommendations
          </Typography>
          <List dense>
            {data.grades.reason.map((reason, index) => (
              <ListItem key={index}>
                <ListItemText primary={`⚠️ ${reason}`} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Cookies Table */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Detailed Cookie Information
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Category</strong></TableCell>
                  <TableCell><strong>Expires</strong></TableCell>
                  <TableCell><strong>Vulnerabilities</strong></TableCell>
                  <TableCell><strong>Purpose</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.result.cookies.map((cookie, index) => (
                  <TableRow key={index}>
                    <TableCell>{cookie.name}</TableCell>
                    <TableCell>{cookie.category}</TableCell>
                    <TableCell>{cookie.expires}</TableCell>
                    <TableCell>
                      {cookie.vulnerabilities.length > 0 ? cookie.vulnerabilities.join(", ") : "None"}
                    </TableCell>
                    <TableCell>{cookie.purpose}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
    </Paper>
  );
}

export default CookieScanReport;
